// extracted by mini-css-extract-plugin
export default {"control":"Control_control__NEoNd","button":"Control_button__G1wJH","download":"Control_download__yu-f3","remove":"Control_remove__PKnqq"};